import { render, staticRenderFns } from "./EducationHistory.vue?vue&type=template&id=01365e78&"
import script from "./EducationHistory.vue?vue&type=script&lang=ts&"
export * from "./EducationHistory.vue?vue&type=script&lang=ts&"
import style0 from "./EducationHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports